import { Chip } from "@material-ui/core";
import { CheckCircle, ErrorRounded, WallpaperRounded } from "@material-ui/icons";
import { useMemo } from "react";

export function StatusField(props) {

  const text = useMemo(() => {
    switch (props.record.status) {
      case 'approved': return 'Deferido';
      case 'rejected': return 'Indeferido';
      default: return 'Pendente';
    }
  }, [props.record])

  const icon = useMemo(() => {
    switch (props.record.status) {
      case 'approved': return <CheckCircle />;
      case 'rejected': return <ErrorRounded />;
      default: return <WallpaperRounded />;
    }
  }, [props.record])

  return <Chip size={'small'} label={text} color={'primary'} icon={icon} />
}
